import { Card } from 'antd'
import { CLASS_TYPE_LABEL } from '../constants'
import { BillingMode, GenerateClassRecordTemplate } from '../types'
import { WeekdayTagList } from './WeekdayTagList'

type ConfigDetailSectionsProps = {
  weekdays: number[]
  isAllDayPricing: boolean
  monthlyPrice?: number | null
  templates: GenerateClassRecordTemplate[]
}

function getTemplatePriceLabel(
  template: GenerateClassRecordTemplate,
  fallbackMonthlyPrice?: number | null,
) {
  if (template.billingMode === BillingMode.ALL_DAY) {
    return '-'
  }
  if (template.billingMode === BillingMode.GIFT) {
    return '-'
  }

  const price = template.coursePrice ?? fallbackMonthlyPrice ?? null
  return price === null ? '-' : `¥${price}`
}

export function ConfigDetailSections({
  weekdays,
  isAllDayPricing,
  monthlyPrice,
  templates,
}: ConfigDetailSectionsProps) {
  return (
    <div className="flex flex-col gap-4">
      {isAllDayPricing &&
      monthlyPrice !== undefined &&
      monthlyPrice !== null ? (
        <Card size="small" title="全天班费用">
          <div className="text-2xl font-semibold text-orange-600">
            ¥{monthlyPrice}
          </div>
        </Card>
      ) : null}

      <Card size="small" title="周几上课">
        <WeekdayTagList weekdays={weekdays} size="lg" />
      </Card>

      <Card size="small" title="模板明细">
        <div className="space-y-4">
          {templates.map((template, index) => (
            <div
              key={`${index}-${template.teacherId ?? 'teacher'}-${template.classType}-${template.billingMode}`}
              className="rounded-2xl border border-slate-200 bg-white px-4 py-4 shadow-sm"
            >
              <div className="text-sm font-semibold text-slate-900">
                配置 {index + 1}
              </div>
              <div className="mt-4 grid grid-cols-1 gap-3 md:grid-cols-4">
                <div className="rounded-xl bg-slate-50 px-3 py-3">
                  <div className="text-xs font-medium text-slate-500">
                    课程类型
                  </div>
                  <div className="mt-1 text-sm font-semibold text-slate-900">
                    {CLASS_TYPE_LABEL[template.classType] || template.classType}
                  </div>
                </div>
                <div className="rounded-xl bg-slate-50 px-3 py-3">
                  <div className="text-xs font-medium text-slate-500">老师</div>
                  <div className="mt-1 text-sm font-semibold text-slate-900">
                    {template.teacherName ||
                      (template.teacherId ? `ID:${template.teacherId}` : '-')}
                  </div>
                </div>
                <div className="rounded-xl bg-slate-50 px-3 py-3">
                  <div className="text-xs font-medium text-slate-500">
                    收费类型
                  </div>
                  <div className="mt-1 text-sm font-semibold text-slate-900">
                    {template.billingMode === BillingMode.PER_CLASS
                      ? '按节收费'
                      : template.billingMode === BillingMode.MONTHLY
                        ? '按月收费'
                        : template.billingMode === BillingMode.ALL_DAY
                          ? '全天班'
                          : '赠课'}
                  </div>
                </div>
                <div className="rounded-xl bg-slate-50 px-3 py-3">
                  <div className="text-xs font-medium text-slate-500">价格</div>
                  <div className="mt-1 text-sm font-semibold text-slate-900">
                    {isAllDayPricing
                      ? '-'
                      : getTemplatePriceLabel(template, monthlyPrice)}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Card>
    </div>
  )
}
